module.exports = __webpack_public_path__ + "img/reset-password-v2.cb5ebb88.svg";